package com.cybersoftsolution.cybersoftsolutionweb.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButton
import com.cybersoftsolution.cybersoftsolutionweb.components.buttons.MyButtonType
import com.cybersoftsolution.cybersoftsolutionweb.components.switchs.MySwitch
import com.cybersoftsolution.cybersoftsolutionweb.models.Page
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.deletePostsButtonId
import com.stevdza.san.kotlinbs.components.BSDropdown
import com.stevdza.san.kotlinbs.models.DropdownDirection
import com.stevdza.san.kotlinbs.models.button.ButtonSize
import com.stevdza.san.kotlinbs.models.button.ButtonVariant
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh



@Composable
inline fun <reified T : MyElement> PageableLayout(
    canSelectElements: Boolean = false,
    crossinline setSelectElements: (Boolean) -> Unit = {},
    limitOfElements: Int? = 4,
    crossinline setLimitOfElements:(Int) -> Unit = {},
    page: Page<T>?,
    isSearching: Boolean = true,
    crossinline goToPage: (Int) -> Unit = {},
    crossinline showMore: (page: Int) -> Unit,
    crossinline onDeleteClick: () ->Unit = {},
    crossinline onEditClick: () ->Unit = {},
    crossinline content: @Composable (elements: List<T>) -> Unit
){


    val placeholder= " Elementos"
    var limit by remember { mutableStateOf("$limitOfElements$placeholder") }
    var infiniteMode by remember { mutableStateOf(false) }


    val modifierContent = Modifier
        .fillMaxWidth(if (isDesktop()) {100.percent} else {95.percent})


    val modifierSwitch = Modifier

        .margin(
            leftRight = if (isDesktop()) {18.px} else {0.px},
            topBottom = if (isDesktop()) {0.px} else {12.px},
        )

    if (page == null || page.list.isEmpty()) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier
                .height(70.vh)
        ) {
            SpanText(
                text = if (isSearching) {
                    "Cargando..."
                } else {
                    "No hay datos"
                }
            )
        }

    } else {
        Column(
            modifier = modifierContent

        ) {
            SimpleGrid(
                modifier = Modifier
                    .fillMaxWidth()
                    .margin(bottom = 12.px),
                numColumns = numColumns(
                    base = 1,
                    sm = 1,
                    md = 2,
                    lg = 2
                )
            ){

                Row(
                    horizontalArrangement = if (isDesktop()) {Arrangement.Start} else {Arrangement.Center},
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    MySwitch(
                        isChecked = canSelectElements,
                        visible = page.list.isNotEmpty(),
                        modifier = modifierSwitch,
                        text = if (page.list.count { it.selected }>0) {
                            if (page.list.count { it.selected }==1) {"1 Elemento seleccionado"} else {"${page.list.count { it.selected }} Elementos seleccionados"}
                        } else {
                            "Seleccionar"
                        },
                        onChange = {
                            setSelectElements(it)
                        }
                    )
                }



                Row(
                    horizontalArrangement = if (isDesktop()) {Arrangement.End} else {Arrangement.SpaceBetween},
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier
                        .fillMaxWidth()
                ) {
                    MyButton(
                        modifier = Modifier
                            .margin(leftRight = 4.px),
                        width = 120.px,
                        enabled = page.list.count { it.selected } == 1,
                        id = deletePostsButtonId,
                        text = "Editar",
                        buttonType = MyButtonType.Edit,
                        onClick = {
                            onEditClick()
                        }
                    )
                    MyButton(
                        modifier = Modifier
                            .margin(leftRight = 4.px),
                        width = 120.px,
                        enabled = !page.list.none { it.selected },
                        id = deletePostsButtonId,
                        text = "Eliminar",
                        buttonType = MyButtonType.Delete,
                        onClick = {
                            onDeleteClick()
                        }
                    )
                }


            }


            content(page.list)

            Row(
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .fillMaxWidth()
            ) {


                BSDropdown(
                    disabledItems = if (infiniteMode) {listOf("Infinito")} else {listOf("$limitOfElements")},
                    direction = DropdownDirection.Top,
                    size = ButtonSize.Small,
//                    placeholder = "$limit$placeholder",
                    selectedItem = limit,
                    items = listOf("1","2","4","10", "20", "50", "100","Infinito"),//.map { it+placeholder },
                    onItemSelect = { index, value ->
                        if (value == "Infinito") {
                            infiniteMode = true
                            limit = "Infinito"
                        } else {
                            infiniteMode = false
                            setLimitOfElements(value.toInt())
                            limit = "$value$placeholder"
                        }

                    },
                    style = ButtonVariant.LinkOutline
                )

                if (!infiniteMode) {
                    Link(
                        modifier = Modifier
                            .margin(leftRight = 4.px)
                            .thenIf(
                                condition = page.prevPage != null,
                                other = Modifier
                                    .onClick {
                                        goToPage(page.prevPage?:1)
                                    }
                            )

                            .thenIf(
                                condition = page.prevPage == null,
                                other = Modifier
                                    .color(Theme.HalfBlack.rgb)
                                    .cursor(Cursor.Default)
                            )
                            .fontSize(16.px)
                        ,
                        path = "",
                        text = "Anterior"
                    )

                    repeat(page.totalPages) { pageInt ->
                        Link(
                            modifier = Modifier
                                .margin(leftRight = 4.px)
                                .thenIf(
                                    condition = pageInt+1 != page.currentPage,
                                    other = Modifier
                                        .onClick {
                                            goToPage(pageInt+1)
                                        }
                                )

                                .thenIf(
                                    condition = pageInt+1 == page.currentPage,
                                    other = Modifier
                                        .color(Theme.HalfBlack.rgb)
                                        .cursor(Cursor.Default)
                                )
                                .fontSize(16.px)
                            ,
                            path = "",
                            text = (pageInt+1).toString()
                        )
                    }

                    Link(
                        modifier = Modifier
                            .margin(leftRight = 4.px)
                            .thenIf(
                                condition = page.nextPage != null,
                                other = Modifier
                                    .onClick {
                                        goToPage(page.nextPage?:1)
                                    }
                            )

                            .thenIf(
                                condition = page.nextPage == null,
                                other = Modifier
                                    .color(Theme.HalfBlack.rgb)
                                    .cursor(Cursor.Auto)
                            )
                            .fontSize(16.px)
                        ,
                        path = "",
                        text = "Siguiente"
                    )
                } else {
                    Link(
                        modifier = Modifier
                            .margin(leftRight = 4.px)
                            .thenIf(
                                condition = page.nextPage != null && !isSearching,
                                other = Modifier
                                    .onClick {
                                        showMore(page.nextPage?:1 )
                                    }
                            )

                            .thenIf(
                                condition = page.nextPage == null,
                                other = Modifier
                                    .color(Theme.HalfBlack.rgb)
                                    .cursor(Cursor.Auto)
                            )
                            .fontSize(16.px)
                        ,
                        path = "",
                        text = if (isSearching) {
                            "Cargando ..."
                        } else {
                            if (page.nextPage != null) {
                                "Cargar mas"
                            } else {
                                ""
                            }

                        }
                    )
                }




            }


        }

    }



}